    const AppConstants = {
        DRAFT_FEEDBACKS_PREFIX: "draft-feedback-",
        PURGE_VERSIONS: {
            VERSION_LIMIT: 25,
            SIZE_LIMIT: 50 * 1024 * 1024 * 1024
        },
        SORT_ORDER: {
            ASCENDING: "ASCENDING",
            DESCENDING: "DESCENDING"
        },
        APPROVAL_VIEW_TYPES: {
            ASSIGNED: 'ASSIGNED',
            TAKENACTION: 'TAKENACTION',
            OWN: "OWN"
        },
        APPROVAL_LIST_VIEW: {
            SORT_COLUMNS: {
                DATE: "DATE"
            }
        },
        TASK_TYPES: {
            REQUEST_FEEDBACK: "REQUEST_FEEDBACK",
            REQUEST_ACCESS: "REQUEST_ACCESS",
            TODO_TASK: "TODO_TASK",
            TRANSFER_RESOURCE_OWNERSHIP: "TRANSFER_RESOURCE_OWNERSHIP",
            NOTIFY_ADMIN_TO_DO: "NOTIFY_ADMIN_TO_DO"
        },
        TASKDEF_IDS: {
            REQUEST_ACCESS: "cdb892f8-b9cf-49c6-8a3a-a7e678af4002",
            TODO_TASK: "b250c0ca-87c3-4f71-9842-5c2eb39c9542",
            TRANSFER_RESOURCE_OWNERSHIP: "d72aj9e3-a21h-37c5-b8d456se2008",
            NOTIFY_ADMIN_TO_DO: "d360c0ca-87c3-15h2-0205-9542e5c2b39c",
            REQUEST_FEEDBACK: "c8f66ee1-00c1-46cb-bed3-52c6e4fb22f0",
        },
        TASK_ACTION_IDS: {
            APPROVE: 'APPROVE',
            REJECT: 'REJECT',
            GIVEFEEDBACK: 'GIVEFEEDBACK',
            REJECTFEEDBACKREQUEST: 'REJECTFEEDBACKREQUEST',
            COMPLETE: 'COMPLETE'
        },
        LIMITS: {
            //Is this bytes, if char, in what encoding?
            RESOURCE_NAME_CHAR_LIMIT: 128,
            HUNDRED_MB_IN_BYTES: 104857600,
            THIRTY_MB_IN_BYTES: 31457280,
            FIFTY_MB_IN_BYTES: 52428800,
            CONCURRENT_OPERATION: 20
        },
        APP_LOCK_IDS: {
            HANCOM: 'Hancom',
            O365: 'WOPI'
        },
        APP_UNLOCK_STATUS: {
            COMPLETE: 'COMPLETE',
            TIMEOUT: 'TIMEOUT',
            PENDING: 'PENDING'
        },
        LOCK_TYPES: {
            APP: 'APP',
            USER: 'USER'
        },
        O365: {
            MAX_TIME_LIMIT_IN_RETRYING_FOR_UNLOCK_IN_SEC: 8,
            MAX_TIME_LIMIT_IN_WAITING_FOR_UNLOCK_IN_SEC: 5,
        },
        Tasks: {
            MetadataFields: {
                ADDITIONAL_COMMENT: 'ADDITIONAL_COMMENT'
            },
            Views: {
                MyTasks: 'MyTasks',
                AssignedTasks: 'AssignedTasks',
                ArchivedTasks: 'ArchivedTasks'
            },
            State: {
                APPROVE: 'APPROVED_STATE',
                REJECT: 'REJECTED_STATE',
                COMPLETE: 'COMPLETED',
                FEEDBACK_GIVEN_STATE: 'FEEDBACK_GIVEN_STATE',
                REJECTED_REQUEST_STATE: 'REJECTED_REQUEST_STATE',
            }
        },
        TASK_RELATED_RESOURCE_TYPES: {
            FOLDER: 'Folder',
            DOCUMENT: 'Document'
        },
        FRE_LOCAL_STORAGE: {
            FEEDBACK_FILTER: 'wd_fre_feedback_filter'
        },
        FEATURE_NOTIFICATION_PERIOD_BUCKET: 'https://s3.amazonaws.com/amazonworkdocs.com/feature-notification/',
        DYKM_URL_PREFIX: 'https://s3.amazonaws.com/amazonworkdocs.com/ddyk-messages/',
        DID_YOU_KNOW_SNOOZE_TIME_MILLISEC: 5 * 24 * 60 * 60 * 1000, //5 days
        DID_YOU_KNOW_SNOOZE_KEY: "wd_did_you_know_snooze_time_start",
        ACCESS_TOKEN_EXPIRIRATION_TIME_IN_SEC: 60 * 60,
        PDF_VIEWER_BASE_URL: "pdfjs",
        WOPI_TEST_EXT: '.wopitest',
        FE_CONN_TOKEN_AND_KEY_STORAGE_NAME_PREFIX: 'fe_connToken_key_',
        USER_INFO_EXPIRY_IN_HRS: 7,
        USER_INFO_LOCAL_STORAGE_KEY: 'user_info_common',
        MEETING_FOLDER_PREFIX: '1A089729-690B-45D3-B177-E2993D649AD8_',
        MEETING_ROOT_FOLDER_NAME: 'Meeting-Files',
        ORG_FEATURES: {
            O365: "WorkDocs.O365",
            ONLINE_EDITING: "WorkDocs.OnlineEditing",
            INDEX_CONTENT_FOR_SEARCH: "WorkDocs.IndexContentForSearch",
            MEETINGS: "WorkDocs.Meetings"
        },
        TOOLTIP_PLACEMENTS: {
            TOP: 'top',
            LEFT: 'left',
            BOTTOM: 'bottom',
            RIGHT: 'right'
        },
        DOCUMENT_VERSION_STATUS: {
            ACTIVE: 'ACTIVE',
            DRAFT: 'DRAFT',
            REVERT: 'REVERT'
        },

        FEEDBACK_VISIBILITY: {
            PUBLIC: "PUBLIC",
            PRIVATE: "PRIVATE",
        },

        FEEDBACK_RESOLUTION_STATUS: {
            RESOLVED: "RESOLVED",
            UNRESOLVED: "UNRESOLVED",
        },
        FEEDBACK_FILTER_INTIAL_STATE: {
            user: '',
            version: '',
            drafts: true,
            published: true,

            resolved: false,
            unresolved: true,

            mentions: false
        },

        // TODO (vivitsum): Change this to the correct domain name once we have it
        PROD_NEWS_SITE_URL: 'https://d1fufgn49q9o1i.cloudfront.net',
        PREVIEW_NEWS_SITE_URL: 'https://d1qi6uk4vfu0bz.cloudfront.net',
        LOGO_URL_PREFIX: 'https://s3.amazonaws.com/amazonworkdocs.com/client-logos/',
        MARKETPLACE_LINK: 'https://aws.amazon.com/marketplace/search/results?searchTerms=workdocs&page=1&ref_=nav_search_box',
        ActivityTypes: {
            CHECKOUT: 'CHECKOUT',
            CHECKIN: 'CHECKIN',
            REVERT: 'REVERT',
            DOCUMENT_LOCKED_FOR_COMMENTS: 'DOCUMENT_LOCKED_FOR_COMMENTS',
            DOCUMENT_UNLOCKED_FOR_COMMENTS: 'DOCUMENT_UNLOCKED_FOR_COMMENTS',
            NEW_VERSION_UPLOADED: 'NEW_VERSION_UPLOADED',
            NEW_DOCUMENT_VERSION_UPLOADED: 'NEW_DOCUMENT_VERSION_UPLOADED',
            SHARED: 'SHARED',
            CREATED_SHAREABLE_LINK: 'CREATED_SHAREABLE_LINK',
            FEEDBACK_REQUESTED: 'FEEDBACK_REQUESTED',
            FEEDBACK_REPLIED: 'FEEDBACK_REPLIED',
            FEEDBACK_PROVIDED: 'FEEDBACK_PROVIDED',
            TRANSFERRED_OWNERSHIP: 'TRANSFERRED_OWNERSHIP',
            DEFAULT: 'DEFAULT'
        },
        ActivityResourceTypes: {
            DOCUMENT: 'document',
            FOLDER: 'folder'
        },
        SERVICE_RECOVERY_DELAY: 5 * 1000,
        HTTP_THROTTLE_MAX_RETRY_COUNT: 3,
        HTTP_THROTTLE_MAX_RETRY_TIME_IN_SEC: 16,
        HTTP_THROTTLE_RETRY_DELAY_IN_MILLISEC: 100,
        ANNOTATION_TYPE: {
            HIGHLIGHT: 'HIGHLIGHT',
            REGION: 'REGION'
        },
        GB_SEARCH: {
            SEARCH_SUBMITTED: 'GB_SEARCH.SEARCH_SUBMITTED',
            SEARCH_CLOSED: 'GB_SEARCH.SEARCH_CLOSED'
        },
        SkuType: {
            BASIC: 'BASIC',
            ADVANCED: 'ADVANCED'
        },
        APP_NAME: 'WorkDocs',

        BYTES_TO_GIGABYTES: 1073741824,
        SECONDS_IN_DAY: 86400, //60 * 60 * 24

        ClientDownloadUrl: {
            ALL: {
                DE: 'https://amazonworkdocs.com/de/clients',
                EN: 'https://amazonworkdocs.com/en/clients',
                ES: 'https://amazonworkdocs.com/es/clients',
                FR: 'https://amazonworkdocs.com/fr/clients',
                JA: 'https://amazonworkdocs.com/ja/clients',
                KO: 'https://amazonworkdocs.com/ko/clients',
                'PT-BR': 'https://amazonworkdocs.com/pt/clients',
                'ZH-CN': 'https://amazonworkdocs.com/zh/clients'
            },
            MAC: 'https://d28gdqadgmua23.cloudfront.net/mac/Amazon WorkDocs.pkg',
            WINDOWS: 'https://d28gdqadgmua23.cloudfront.net/win/AmazonWorkDocsSetup.exe'
        },

        FrictionlessClientUrl: {
            MAC_ALPHA: 'https://s3.amazonaws.com/gb-aurelius-alpha/mac/latest_version/Amazon WorkDocs Companion.pkg',
            MAC_GAMMA: 'https://s3.amazonaws.com/gb-aurelius-gamma/mac/latest_version/Amazon WorkDocs Companion.pkg',
            MAC_PREVIEW: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-preview/mac/latest_version/Amazon WorkDocs Companion.pkg',
            MAC_PROD: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/mac/latest_version/Amazon WorkDocs Companion.pkg',
            WINDOWS_ALPHA: 'https://s3.amazonaws.com/gb-aurelius-alpha/windows/latest_version/Amazon WorkDocs Companion.msi',
            WINDOWS_GAMMA: 'https://s3.amazonaws.com/gb-aurelius-gamma/windows/latest_version/Amazon WorkDocs Companion.msi',
            WINDOWS_PREVIEW: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-preview/windows/latest_version/Amazon WorkDocs Companion.msi',
            WINDOWS_PROD: 'https://s3-us-west-2.amazonaws.com/gb-aurelius-prod/windows/latest_version/Amazon WorkDocs Companion.msi'
        },

        CollaboratorTypes: {
            ANONYMOUS: 'ANONYMOUS',
            GROUP: 'GROUP',
            INVITE: 'INVITE',
            ORGANIZATION: 'ORGANIZATION',
            USER: 'USER'
        },

        SharedLinkScope: {
            ANONYMOUS: 'ANYONE',
            SITE_VIEWER: 'SITE_VIEWER',
            SITE_CONTRIBUTOR: 'SITE_CONTRIBUTOR'
        },

        DeleteTypes: {
            DELETE_TYPE_RECYCLE: 'RECYCLE',
            DELETE_TYPE_PERMANENT: 'PERMANENT'
        },

        DocumentStatus: {
            DOCUMENT_STATUS_ACTIVE: 'ACTIVE',
            DOCUMENT_STATUS_PENDING: 'PENDING',
            DOCUMENT_STATUS_FAILED: 'FAILED',
            DOCUMENT_STATUS_PENDING_USER_ACTION: 'PENDING_USER_ACTION',
            DOCUMENT_STATUS_UNSUPPORTED: 'UNSUPPORTED'
        },

        DOC_LEVEL: 'Overall',

        DRAFT_COLOR: '#1B8DE2',

        ErrorTypes: {
            SUCCESS: 'SUCCESS',
            FRE: 'FRE', //First run experience
            UPLOAD: 'UPLOAD',
            DELETE: 'DELETE',
            SHARE: 'SHARE',
            TRANSIENT_ERROR: 'TRANSIENT_ERROR',
            DEFAULT: 'ERROR',
            INFO: 'INFO',
            IE: 'IE',
            MOVE: 'MOVE'
        },

        FeedbackTypes: {
            FEEDBACK_TYPE_DRAFT: 'DRAFT',
            FEEDBACK_TYPE_INPUT: 'INPUT',
            FEEDBACK_TYPE_PUBLISHED: 'PUBLISHED',
            FEEDBACK_TYPE_DELETED: "DELETED",
            FEEDBACK_TYPE_FAILED: 'FAILED',
            FEEDBACK_TYPE_RETRY: 'RETRY' //Means retrying
        },

        FileConstants: {
            DEFAULT_SERVICE_MAX_ITEMS: 24
        },

        FolderContentTypes: {
            ALL: 'ALL',
            DOCUMENT: 'DOCUMENT',
            FOLDER: 'FOLDER'
        },

        GlobalRoles: {
            OWNER: 'OWNER',
            COOWNER: 'COOWNER',
            CONTRIBUTOR: 'CONTRIBUTOR',
            VIEWER: 'VIEWER'
        },

        GalleryTypes: {
            THUMBNAIL_VIEWTYPE: 'THUMBNAIL',
            LIST_VIEWTYPE: 'LIST'
        },

        HttpMethods: {
            DELETE: 'DELETE',
            GET: 'GET',
            PATCH: 'PATCH',
            POST: 'POST',
            PUT: 'PUT'
        },

        HttpStatuses: {
            UNAUTHORIZED: 401,
            FORBIDDEN: 403,
            NOT_FOUND: 404,
            CONFLICT: 409,
            LOCKED: 423,
            BAD_REQUEST: 400,
            ENTITY_TOO_LARGE: 413,
            DEPENDENCY_FAILURE: 424
        },

        LayoutViewTypes: {
            VIEW_FAVORITES_LAYOUT: 'FAVORITES',
            VIEW_DOCUMENT_LAYOUT: 'DOCUMENT',
            VIEW_QUARTZ_DOCUMENT_LAYOUT: "QUARTZ",
            VIEW_FOLDER_LAYOUT: 'FOLDER',
            MYDOCS_FOLDER_LAYOUT: 'OWNED',
            VIEW_ADMIN_LAYOUT: 'ADMIN',
            VIEW_PROFILE_LAYOUT: 'PROFILE',
            VIEW_ANALYTICS_LAYOUT: 'ANALYTICS',
            VIEW_OFFICE_EDITOR_LAYOUT: 'OFFICEEDITOR',
            VIEW_ANALYTICS_DASHBOARD_LAYOUT: 'ANALYTICS_DASHBOARD',
            APPROVALS_VIEW: "APPROVALS"
        },

        LocaleValues: [{
            Code: 'en',
            Locale: 'English (United States)'
        }, {
            Code: 'zh_CN',
            Locale: 'Chinese (Simplified) - 中文（简体中文）'
        }, {
            Code: 'zh_TW',
            Locale: 'Chinese (Traditional) - 中文（繁體）'
        }, {
            Code: 'ja',
            Locale: 'Japanese - 日本語'
        }, {
            Code: 'pt_BR',
            Locale: 'Portuguese (Brazil) - português (Brasil)'
        }, {
            Code: 'de',
            Locale: 'German - Deutsch'
        }, {
            Code: 'fr',
            Locale: 'French - français'
        }, {
            Code: 'ko',
            Locale: 'Korean - 한국어'
        }, {
            Code: 'es',
            Locale: 'Spanish - español'
        }, {
            Code: 'ru',
            Locale: 'Russian - русский'
        }],

        MARKER: 'MARKER',
        MAX_CHARS: 2048,
        MAX_DOCS: 800,

        Orientation: {
            FORWARD: 'FORWARD',
            BACKWARD: 'BACKWARD'
        },

        OSTypes: {
            MAC: 'Mac',
            WINDOWS: 'Windows',
            iOS: 'iOS',
            Android: 'Android'
        },

        Pagination: {
            FIRST: 'FIRST',
            PREVIOUS: 'PREVIOUS',
            NEXT: 'NEXT',
            LAST: 'LAST'
        },
        PAGINATION_LIMIT: 5,

        Paths: {
            MY_DOCS: '/mydocs',
            DOCUMENT: '/document/:documentId'
        },

        Permissions: {
            CHECKOUT: 'CHECKOUT',
            CHECKIN: 'CHECKIN',
            DISCARD_CHECKOUT: 'DISCARD_CHECKOUT',
            REQUEST_FEEDBACK: 'REQUEST_FEEDBACK',
            SHARE: 'SHARE',
            CONTRIBUTE: 'CONTRIBUTE',
            GRANTED: 'GRANT',
            REVOKED: 'REVOKE',
            VIEW: 'VIEW',
            DOWNLOAD: 'DOWNLOAD',
            UPLOAD: 'UPLOAD',
            DELETE: 'DELETE',
            MOVE: 'MOVE',
            RENAME: 'RENAME',
            REMOVE_FORM_SHARE: 'REMOVE_FORM_SHARE'
        },

        PreviewSite: {
            WEB_PROD_PREF: 'prod',
            WEB_PREVIEW_PREF: 'previewsite',
            WEB_NOVA_PREF: 'novasite',
            PREVIEW_URL_COMPONENT: '/workdocs-beta/',
            PROD_URL_COMPONENT: '/workdocs/'
        },

        NovaURLs: {
            ALPHA: '/gba-flight3/',
            GAMMA: '/gbinternal-flight3/',
            PROD: '/workdocs-preview/',
            PROD_AMAZON: '/workdocs-amazon/'
        },

        RainierURLs: {
            ALPHA: '/gba/',
            GAMMA: '/gbinternal/',
            PROD: '/workdocs/'
        },

        NovaOnboardingGroups: {
            BRAVEHEARS_OPT_IN: 'nova-preview-opt-in',
            BRAVEHEARS_OPT_IN_EXTENSION_1: 'nova-preview-opt-in-extension-1',
            BRAVEHEARS_OPT_IN_EXTENSION_2: 'nova-preview-opt-in-extension-2',
            ALL_AWS_EMPLOYEES: 'all-aws-employees',
            NOVA_QUARTZ_USERS: 'nova-quartz-users',
            DILIP_REPORTS: 'dilip-reports',
            NOVA_REDIRECT_EXCLUSION_LIST: 'nova-exclusion-list'
        },

        NovaUsersForcedInGroup: {
            BRAVEHEARTS: 'nova-bravehearts'
        },

        PrincipalTypes: {
            GROUP: 'GROUP',
            ORGANIZATION: 'ORGANIZATION',
            USER: 'USER'
        },

        DocumentTypes: {
            NOTE: 'NOTE'
        },

        ResourceStatus: {
            RESOURCE_STATUS_RECYCLED: 'RECYCLED',
            RESOURCE_STATUS_RECYCLING: 'RECYCLING'
        },

        RightTabTypes: {
            PEOPLE_TAB: 'People',
            FEEDBACK_TAB: 'Feedback',
            SECURITY_TAB: 'Security',
            VIEW_TAB: 'View',
            CONTRIBUTOR_TABS: ['People', 'Feedback', 'Security'],
            VIEWER_TABS: ['People', 'Security'],
            NEW_APPROVAL_REQUEST_TAB: 'NewApprovalRequest',
            APPROVALS_PEOPLE_TAB: 'ApprovalsPeople',
            APPROVALS_FILES_TAB: 'ApprovalsFiles',
            APPROVALS_COMMENTS_TAB: 'ApprovalsComments',
        },

        RoleTypes: {
            DIRECT: 'DIRECT',
            INHERITED: 'INHERITED'
        },

        SupportedFileFormatThumbnail: ['Excel', 'Word', 'Text', 'Powerpoint', 'PDF', 'Image'],

        ThumbnailUrlMap: {
            Excel: 'images/file_format_icons/excel-icon.png',
            Image: 'images/file_format_icons/image-icon.png',
            Other: 'images/file_format_icons/etc-icon.png',
            PDF: 'images/file_format_icons/pdf-icon.png',
            Powerpoint: 'images/file_format_icons/ppt-icon.png',
            Text: 'images/file_format_icons/txt-icon.png',
            Word: 'images/file_format_icons/word-icon.png'
        },

        ViewTypes: {
            ALL_TYPE: 'ALL',
            OWN_TYPE: 'OWNED',
            FAVORITES: 'FAVORITES',
            FOLDER_TYPE: 'FOLDER',
            DOCUMENT_TYPE: 'DOCUMENT',
            SHARED_TYPE: 'SHARED',
            SHARED_BY_ME_TYPE: 'SHARED_BY_ME',
            AWAITING_FEEDBACK_TYPE: 'AWAITING_FEEDBACK',
            OUT_FOR_REVIEW_TYPE: 'OUT_FOR_REVIEW',
            RECYCLE_TYPE: 'RECYCLE',
            NOTE_TYPE: 'NOTE',
            RECOVERY_TYPE: 'RECOVERY',
            SEARCH_TYPE: 'SEARCH',
            DBOARD_TYPE: 'DBOARD'
        },

        LocalStorageKeys: {
            GLOBAL_CLIENT_ERRORS: 'global_client_errors',
            AJAX_CALL_RESULTS: 'ajax_call_results',
            DO_NOT_SHOW_EDIT_RESULT_MODAL: 'do_not_show_edit_result_modal',
        },

        Upload: {
            MAX_NAME_LENGTH: 255,
            MAX_CONCURRENT_UPLOADS: 10
        },

        KeyCodes: {
            ARROW_DOWN: 40,
            ARROW_UP: 38,
            ARROW_LEFT: 37,
            ARROW_RIGHT: 39,
            ENTER: 13,
            ESC: 27,
            F: 70,
            MINUS: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PLUS: 107,
            SPACEBAR: 32
        },
        WordTypes: [
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/vnd.ms-word',
            'application/vnd.ms-word.document.12'
        ],
        UseAnnotationIndexTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/vnd.ms-word',
            'application/vnd.ms-word.document.12',
            'application/pdf'
        ],
        WorkDocsAuthParams: {
            ACCESS_TOKEN: 'access_token',
            ACCESS_TOKEN_EXPIRATION: 'access_token_expiration',
            REFRESH_TOKEN: 'refresh_token'
        },
        AuthType: {
            AUTH_TYPE: 'workdocs_auth_type',
            AUTH_TYPE_LOGINV2: 'loginv2',
            LOGINV2_OPT_IN: 'loginv2OptIn',
            LOGINV2_OPT_IN_TRUE: 'true'
        },
        EditPlatforms: {
            COMPANION: 'COMPANION',
            O365: 'O365',
            HANCOM: 'THINKFREE OFFICE'
        },
        ResourceTypes: {
            FILE: 'file',
            FOLDER: 'folder',
            TASK: 'task'
        },
        RightClickMenus: {
            FILE_SELECTED: 'FILE_SELECTED',
            FOLDER_SELECTED: 'FOLDER_SELECTED',
            TASK_SELECTED: 'TASK_SELECTED',
            MULTI_SELECTED: 'MULTI_SELECTED',
            MULTI_TASK_SELECTED: 'MULTI_TASK_SELECTED'
        },
        ORG_WIDE_SHARING_SCOPE: 'MANAGED'
    };

    /**
     * @ngdoc overview
     * @name AppConstants
     *
     * @description
     * Constants and configurations for the GorillaBoy web application (top-level).
     */
    angular.module('GorillaBoy.common')
    .constant('AppConstants', AppConstants);

export default AppConstants;
